import React, {useState} from 'react';
import { updateCategory } from '../../../services/categoryService';
import { useForm } from 'react-hook-form';
import { useAuth } from '../../../context/AuthContext';
import EditActions from '../../../common/Handler/EditButton';
import ErrorAlert from '../../Notifications/ErrorAlert';
import FormInput from '../../../common/FormInput';

function EditFormCategory({ category, handleCategoryUpdated, editCategory }) {
    const { token } = useAuth(); 
    const [content, setContent] = useState(category.name);
    const { register, handleSubmit, formState: { errors } } = useForm({ defaultValues: { content } });
    const [showErrorAlert, setShowErrorAlert] = useState("");

    const onSubmit = async (data) => {
        try {
            const result = await updateCategory(category._id, data.content, token);
            setContent(data.content);
            handleEditingEnd();
            handleCategoryUpdated(result.category);
        } catch {
            setShowErrorAlert("Erreur lors de l'édition de la catégorie.");
        }
    };

    const handleEditingEnd = () => {
        editCategory(null); 
    };

    return (
        <div className="p-4 border rounded-lg bg-gray-50 shadow-md">
            <form onSubmit={handleSubmit(onSubmit)} className="gap-4">
                <FormInput label="Contenu" name="content" placeholder="Musique" type="textarea" register={register} rules={{ required: "Catégorie requise" }} errors={errors}/>
                <EditActions cancelEdit={handleEditingEnd}/>
            </form> 
            {showErrorAlert && (<ErrorAlert message={showErrorAlert} onClose={() => setShowErrorAlert(false)}/>)}
        </div>
    );
}

export default EditFormCategory;

